import { buildSelector } from '@/shared/lib/store';

export const [useViewerHasDoneOnboarding] = buildSelector(
    (state) => state.viewer?.data?.has_done_onboarding || false,
);
